"use client";

import { c as _c } from "react/compiler-runtime";
import { CONSENT_ESSENTIAL_COOKIE, CONSENT_EULA_COOKIE, CONSENT_PERFORMANCE_COOKIE } from "@/constants";
import { useState } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import Toggle from "react-toggle";
import { getCookieConsentByName, useCookieConsent } from "../cookies/CookieConsentContext";
import styles from "./About.module.scss";
export default function AboutCookiePolicy() {
  const $ = _c(28);
  const {
    showCookieConsent,
    consent,
    reject
  } = useCookieConsent();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getCookieConsentByName(CONSENT_PERFORMANCE_COOKIE);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [isPerformanceCookiesEnabled, setIsPerformanceCookiesEnabled] = useState(t0);
  let t1;
  if ($[1] !== consent || $[2] !== isPerformanceCookiesEnabled || $[3] !== reject) {
    t1 = () => {
      if (isPerformanceCookiesEnabled) {
        reject();
      } else {
        consent();
      }
      setIsPerformanceCookiesEnabled(!isPerformanceCookiesEnabled);
    };
    $[1] = consent;
    $[2] = isPerformanceCookiesEnabled;
    $[3] = reject;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const togglePerformanceCookies = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Row><Col><h1>Cookie Policy</h1></Col></Row>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Row><Col className={`${styles.lastUpdateText} text-right pt-3 pb-3`}>Last Updated: June 04, 2024</Col></Row>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Row className="pb-3"><Col><h3 className="mb-0">Cookie List</h3></Col></Row>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Row><Col><Container className="no-padding">{t4}<Row className="pt-2 pb-2"><Col><p>A cookie is a small piece of data (text file) that a website - when visited by a user - asks your browser to store on your device in order to remember information about you. Those cookies are set by us and called first-party cookies. More specifically, we use cookies and other tracking technologies for the following purposes:</p></Col></Row></Container></Col></Row>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Row className="pb-3"><Col><h4 className="mb-0">Strictly Necessary Cookies</h4></Col></Row>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Row className="pt-2"><Col>These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. These cookies do not store any personally identifiable information.</Col></Row>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Row className="pt-3 pb-3"><Col><Container className="no-padding">{t6}{t7}<Row><Col><Table className={styles.cookiePolicyTable}><thead><tr><th>Domain</th><th>Cookies</th><th>Cookies used</th><th>Lifespan</th></tr></thead><tbody><tr><td>6529.io</td><td><a href="https://cookiepedia.co.uk/cookies/AWSALBTGCORS" target="_blank" rel="noopener noreferrer">AWSALBTGCORS</a>{" "}(Amazon Web Services)</td><td>First Party</td><td>7 days</td></tr><tr><td>6529.io</td><td><a href="https://cookiepedia.co.uk/cookies/AWSALBTG" target="_blank" rel="noopener noreferrer">AWSALBTG</a>{" "}(Amazon Web Services)</td><td>First Party</td><td>7 days</td></tr><tr><td>6529.io</td><td>wallet-auth (JWT Authentication)</td><td>First Party</td><td>7 days</td></tr><tr><td>6529.io</td><td>{CONSENT_ESSENTIAL_COOKIE}</td><td>First Party</td><td>1 year</td></tr><tr><td>6529.io</td><td>{CONSENT_EULA_COOKIE}</td><td>First Party</td><td>1 year</td></tr></tbody></Table></Col></Row></Container></Col></Row>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <h4 className="mb-0">Performance Cookies</h4>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = isPerformanceCookiesEnabled ? "Enabled" : "Disabled";
  let t11;
  if ($[13] !== t10) {
    t11 = <label htmlFor="performance-cookies-toggle" className="font-color"><b>{t10}</b></label>;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== isPerformanceCookiesEnabled || $[16] !== showCookieConsent || $[17] !== togglePerformanceCookies) {
    t12 = <Toggle disabled={showCookieConsent} id="performance-cookies-toggle" checked={isPerformanceCookiesEnabled} onChange={togglePerformanceCookies} />;
    $[15] = isPerformanceCookiesEnabled;
    $[16] = showCookieConsent;
    $[17] = togglePerformanceCookies;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t12) {
    t13 = <Row className="pb-3"><Col className="d-flex align-items-center justify-content-between">{t9}<span className="d-flex align-items-center gap-2">{t11}{t12}</span></Col></Row>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Row className="pt-2"><Col>This website utilizes performance cookies that are stored on your computer. These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help in identifying which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance.</Col></Row>;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Row><Col><Table className={styles.cookiePolicyTable}><thead><tr><th>Domain</th><th>Cookies</th><th>Cookies used</th><th>Lifespan</th></tr></thead><tbody><tr><td>6529.io</td><td>{CONSENT_PERFORMANCE_COOKIE}</td><td>First Party</td><td>1 year</td></tr><tr><td>.6529.io</td><td><a href="https://cookiepedia.co.uk/cookies/_ga_" target="_blank" rel="noopener noreferrer">_ga_71NLVV3KY3</a>{" "}(Google Analytics)</td><td>First Party</td><td>1 year</td></tr><tr><td>.6529.io</td><td><a href="https://cookiepedia.co.uk/cookies/_ga" target="_blank" rel="noopener noreferrer">_ga</a>{" "}(Google Analytics)</td><td>First Party</td><td>1 year</td></tr><tr><td>.6529.io</td><td><a href="https://cookiepedia.co.uk/cookies/_gid" target="_blank" rel="noopener noreferrer">_gid</a>{" "}(Google Analytics)</td><td>First Party</td><td>1 year</td></tr></tbody></Table></Col></Row>;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Row className="pb-3"><Col><h5 className="mb-0">Retention Policy</h5></Col></Row>;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Row className="pt-2"><Col><Container className="no-padding">{t16}<Row><Col>We will retain a record of your acceptance of any performance cookie for the lifespan of the applicable cookie plus up to 30 days thereafter.</Col></Row></Container></Col></Row>;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== t13) {
    t18 = <Container>{t2}{t3}{t5}{t8}<Row className="pt-3 pb-3"><Col><Container className="no-padding">{t13}{t14}{t15}{t17}</Container></Col></Row></Container>;
    $[26] = t13;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  return t18;
}